import ArrowLeftIcon from '@atlaskit/icon/core/arrow-left';
import * as React from 'react';

export function SvgArrowLeft() {
  return <ArrowLeftIcon label="" testId="ads-refreshed-icon" />;
}
